import {useParams} from "react-router-dom";
import MainLocalVideoView from "../../components/video/local/MainLocalVideoView";
import {useEffect, useState} from "react";
import {FileProperty} from "../../components/common/documentviewer/FileProperty";
import {DocumentViewer} from "../../components/common/documentviewer/DocumentViewer";
import {CustomerDto} from "../../dto/CustomerDto";
import adminService from "../../service/adminService";
import {message} from "antd";
import {MSG_FAILED_TO_FETCH_PENDING_DETAIL_VERIFICATION_LIST_ERROR} from "../../util/Messages";
import ErrorHandler from "../../util/ErrorHandler";
import {BASKET_STATUS_ON_BOARDING_BASKET} from "../../util/Constants";

const MainLocalVideoViewPage = (props:any) => {
    const routeParams: { callId: "0" } = useParams();
    const [documentViewWindowList, setDocumentViewWindowList] = useState<Array<FileProperty>>([]);
    const [customerDto, setCustomerDto] = useState<CustomerDto>();
    const[workId,setWorkId]=useState(0)
    const[isApplicableForVideoVerification,setApplicableForVideoVerification]=useState(false)
    const[basketStatus,setBasketStatus]=useState(BASKET_STATUS_ON_BOARDING_BASKET)
    const[cin,setCin]=useState("")
    const addDocumentWindow = (fileProperty: FileProperty, contentType: string) => {
        let documentWindowList: Array<FileProperty> = [];
        documentWindowList.push(fileProperty);
        setDocumentViewWindowList(documentWindowList);
    };
    const getCustomerDetails = (workbasketDto:any) => {
        adminService.getCustomerDetailsForVerification(workbasketDto.workId).then(res => {
            if (res.data !== null) {
                setCustomerDto(res.data.results.customerMstDto)
            } else {
                message.error(MSG_FAILED_TO_FETCH_PENDING_DETAIL_VERIFICATION_LIST_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }
    useEffect(() => {
        const workBasketDataStr = localStorage.getItem("workBasketData");
        const workbasketDto = workBasketDataStr !== null ? JSON.parse(workBasketDataStr) : null;
        setWorkId(workbasketDto.workId)
        setApplicableForVideoVerification(workbasketDto.iSApplicableForVideoVerification)
        setBasketStatus(workbasketDto.basketStatus)
        setCin(workbasketDto.cin)
        getCustomerDetails(workbasketDto)
    }, [props.history.location.state])
    const removeDocumentWindow = (documentTypeId: any) => {
        setDocumentViewWindowList((current) =>
            current.filter((fruit) => fruit.documentId !== documentTypeId)
        );
    };

    return <div>
        {
            documentViewWindowList.map((fileProperty, index) => <div><DocumentViewer
                key={`documentViewer${index}`}
                fileProperty={fileProperty}
                removeDocumentWindow={removeDocumentWindow}/></div>)
        }
        <MainLocalVideoView callId={routeParams.callId} addDocumentWindow={addDocumentWindow}
                            removeDocumentWindow={removeDocumentWindow} customerData={customerDto}
                            workId={workId} isApplicableForVideoVerification={isApplicableForVideoVerification}
                            basketStatus={basketStatus}
                            cin={cin}
        />
    </div>
}

export default MainLocalVideoViewPage
